
/**
 * Combine absolute and relative URLs
 * 
 * example
 * 
 * concat('http://domain.com/', '/aweful/WICKED/', '/hard/', '/to/', 'join/', 'these', 'variants', '?considering=how', '&easy=it', '&is')
 * 
 * >http://domain.com/aweful/WICKED/hard/to/join/these/variants?considering=how&easy=it&is
 */
export function concatUrl(url1: string, ...paths: any[]): string {

  const base = url1.substr(-1) === '/' ? url1 : `${url1}/`;

  return (paths || []).reduce((prev, current) => {
    if (current === undefined || current === null) {
      return prev;
    }
    const path = (current.toString().match(/[^\/\\]+/g) || []).join('/');
    return /[\?|\&|\=]/.test(path) || /\/$/.test(prev) ? `${prev}${path}` : `${prev}/${path}`;
  }, base);
}
